import { DataGrid, DataGridProps } from '@mui/x-data-grid'
import React, { useEffect, useRef } from 'react'
import { useLocales } from '../../hooks/useLocales'
import { Box, Stack } from '@mui/material'

function I18nDataGrid(props: DataGridProps) {
    const { getDataGridLocales } = useLocales()

    return (
        <DataGrid
            autoHeight
            disableColumnFilter
            getRowHeight={() => 'auto'}
            {...props} localeText={getDataGridLocales()}></DataGrid>
    )
}

export default I18nDataGrid